import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { Year } from '../../../shared-components/year/year.model';

@Component({
  selector: 'app-free-reduced-meal-app-year-selector',
  templateUrl: './free-reduced-meal-app-year-selector.component.html',
  styleUrls: ['./free-reduced-meal-app-year-selector.component.css']
})
export class FreeReducedMealAppYearSelectorComponent implements OnInit {

  years: Year[] = [];
  labels: string[] = [];
  ids: string[] = [];
  selectedYear: Year;
  errors: ErrorList[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FreeReducedMealAppYearSelectorComponent>
  ) {
    if (data && data.years) {
      this.years = data.years.filter((o: Year) => o.Status != 0);
      this.years.forEach(year => {
        this.labels.push(year.Description);
        this.ids.push('frmaYear' + year.Id);
      });
    }
   }

  ngOnInit(): void {
  }

  cancelClick() {
    this.dialogRef.close(false);
  }

  nextClick() {
    this.errors = [];
    if (this.selectedYear) {
      this.dialogRef.close(this.selectedYear);
    }
    else {
      this.errors.push({
        fieldName: 'Year',
        fieldRef: null,
        errorMsg: 'Field is required.'
      });
    }
  }

}
